import { render, staticRenderFns } from "./ForwarderManager.vue?vue&type=template&id=5244d8ee&scoped=true"
import script from "./ForwarderManager.vue?vue&type=script&lang=js"
export * from "./ForwarderManager.vue?vue&type=script&lang=js"
import style0 from "./ForwarderManager.vue?vue&type=style&index=0&id=5244d8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5244d8ee",
  null
  
)

export default component.exports